import ExpanderWidget from "csi/expander/Widget";
import declare from "dojo/_base/declare";

const IngredientContributorTable = declare(ExpanderWidget, {

	// Boolean: override to use expandLevel on Custom View
	bSupportsExpandLevelOption: true,

});

export = IngredientContributorTable;
